module.exports = __webpack_public_path__ + "static/media/configure.607d7ae7.svg";